import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { CALL_API } from 'redux-api-middleware';
import { PHARMACY_API, API_ENDPOINT } from '../../../../config/endpoints';
import { getAPIErrorMessage } from '../../api-error';
import { ROUTE } from '../../middleware/route';
import { isPostcodeValid } from '../signup/address';
import {
  isValidAddressLine,
  maxLengthValid,
  notEmptyString,
  validate,
} from '../../middleware/validator';
import paths from '../../../routes/paths';
// eslint-disable-next-line import/no-cycle
import { SET_ERROR_ADDING_ITEM } from '../neworder';
import { addressLineMaxLen } from '../../../../config/utils';
import { preserveSequence } from '../../middleware/sequence';
import { TRACK_EVENT } from '../../middleware/analytics';
import { ORDERING_CHANGE_DELIVERY_PREFERENCE } from '../../../../server/services/analytics-events';
import {
  CLEAR_CHECKOUT_FLOW,
  FETCH_INVOICE_RECEIVE,
  FETCH_INVOICE_REQUEST,
} from '../checkout';
import { CHAIN_NEXT, chainAPIActions } from '../../middleware/chain';

// ACTIONS
export const FETCH_ORDERS_REQUEST = 'ORDERS/FETCH_ORDERS_REQUEST';
export const FETCH_ORDERS_RECEIVE = 'ORDERS/FETCH_ORDERS_RECEIVE';
export const FETCH_ORDERS_FAILURE = 'ORDERS/FETCH_ORDERS_FAILURE';
export const FETCH_DELIVERY_PREFERENCES_RECEIVE =
  'ORDERS/FETCH_DELIVERY_PREFERENCES_RECEIVE';
export const FETCH_DELIVERY_PREFERENCES_REQUEST =
  'ORDERS/FETCH_DELIVERY_PREFERENCES_REQUEST';
export const FETCH_DELIVERY_PREFERENCES_FAILURE =
  'ORDERS/FETCH_DELIVERY_PREFERENCES_FAILURE';
export const ADD_REORDER_ITEM = 'ORDERS/ADD_REORDER_ITEM';
export const UPDATE_ORDER_DELIVERY_ADDRESS_REQUEST =
  'ORDERS/UPDATE_ORDER_DELIVERY_ADDRESS_REQUEST';
export const UPDATE_ORDER_DELIVERY_ADDRESS_RECEIVE =
  'ORDERS/UPDATE_ORDER_DELIVERY_ADDRESS_RECEIVE';
export const UPDATE_ORDER_DELIVERY_ADDRESS_FAILURE =
  'ORDERS/UPDATE_ORDER_DELIVERY_ADDRESS_FAILURE';
export const SET_DELIVERY_ADDRESS_ORDER_ID =
  'ORDERS/SET_DELIVERY_ADDRESS_ORDER_ID';
export const SET_DELIVERY_PREFERENCE_FLOW =
  'ORDERS/SET_DELIVERY_PREFERENCE_FLOW';
export const SET_DELIVERY_PREF_ORDER_ID = 'ORDERS/SET_DELIVERY_PREF_ORDER_ID';
export const CLEAR_UPDATE_ORDER_DELIVERY_ADDRESS_ERROR =
  'ORDER/CLEAR_UPDATE_ORDER_DELIVERY_ADDRESS_ERROR';
export const VALIDATE_ORDER_DELIVERY_ADDRESS_FAILURE =
  'ORDER/VALIDATE_ORDER_DELIVERY_ADDRESS_FAILURE';
export const BASKET_FLOW_STARTED = 'ORDERS/BASKET_FLOW_STARTED';

export const FETCH_CC_STORES = 'ORDER/FETCH_CC_STORES';
export const FETCH_CC_STORES_FAILURE = 'ORDERS/FETCH_CC_STORES_FAILURE';
export const FETCH_CC_STORES_REQUEST = 'ORDERS/FETCH_CC_STORES_REQUEST';
export const FETCH_CC_STORES_RECEIVE = 'ORDERS/FETCH_CC_STORES_RECEIVE';
export const SET_CC_STORES_SEARCHING = 'ORDERS/SET_CC_STORES_SEARCHING';
export const SELECTED_CCSTORE_ITEM = 'ORDERS/SELECTED_CCSTORE_ITEM';
export const SET_ERROR_ADDING_CCSTORE_ITEM =
  'ORDERS/SET_ERROR_ADDING_CCSTORE_ITEM';
const CLEAR_ERROR_ADDING_ITEM = 'ORDERS/CLEAR_ERROR_ADDING_ITEM';
const SELECTCCPharmacyINDEX = 'ORDERS/SELECT_CC_Pharmacy_INDEX';
export const SELECTED_CONFIRM_ITEM = 'ORDERS/SELECTED_CONFIRM_ITEM';
export const SET_EMPTY_LIST = 'ORDERS/SET_EMPTY_LIST';
export const UPDATE_DELIVERY_PREFS_RESPONSE =
  'ORDERS/UPDATE_DELIVERY_PREFS_RESPONSE';
export const UPDATE_DELIVERY_PREFS_REQUEST =
  'ORDERS/UPDATE_DELIVERY_PREFS_REQUEST';
export const UPDATE_DELIVERY_PREFS_FAILURE =
  'ORDERS/UPDATE_DELIVERY_PREFS_FAILURE';
export const FETCH_ORDER_DETAILS = 'ORDERS/FETCH_ORDER_DETAILS';
export const FETCH_ORDER_DETAILS_REQUEST = 'ORDERS/FETCH_ORDER_DETAILS_REQUEST';
export const FETCH_ORDER_DETAILS_RESPONSE =
  'ORDERS/FETCH_ORDER_DETAILS_RESPONSE';
export const FETCH_ORDER_DETAILS_FAILURE = 'ORDERS/FETCH_ORDER_DETAILS_FAILURE';
export const SEARCH_CCPHARMACY_VALIDATION =
  'ORDERS/SEARCH_CCPHARMACY_VALIDATION';
export const CCORDERID_REQUEST = 'ORDERS/CCORDERID_REQUEST';
export const CCORDERID_RESPONSE = 'ORDERS/CCORDERID_RESPONSE';
export const CCORDERID_FAILURE = 'ORDERS/CCORDERID_FAILURE';
export const UPDATE_DELIVERY_RECEIVE = 'ORDERS/UPDATE_DELIVERY_RECEIVE';
export const UPDATE_DELIVERY_REQUEST = 'ORDERS/UPDATE_DELIVERY_REQUEST';
export const UPDATE_DELIVERY_FAILURE = 'ORDERS/UPDATE_DELIVERY_FAILURE';
export const PAMENTSUMMARY_ROUTES = 'ORDERS/PAMENTSUMMARY_ROUTES';
export const PAYMENT_DELIVERY_PREFS_ROUTES = 'ORDERS/PAYMENT_DELIVERY_PREFS_ROUTES';
export const CONFIRM_EXEMPTION_ROUTES = 'ORDERS/CONFIRM_EXEMPTION_ROUTES';
export const SET_PAMENT_SUMMARY_TYPE = 'ORDERS/SET_PAMENT_SUMMARY_TYPE';
export const SET_PAYMENT_ADDRESS_TYPE = 'SET_PAYMENT_ADDRESS_TYPE';
export const CLEAR_CC_STORE = 'CLEAR_CC_STORE';

// ACTION CREATORS
export const checkIfUserHasInvoicedOrders = (orders = []) =>
  !!orders.filter(
    (order) => order.status !== 'created' && order.status !== 'sent_to_gp' && order.status !== 'rejected'
  ).length;

export const fetchOrders = (apiEndpoint = PHARMACY_API, redirectRoute) => ({
  [CALL_API]: {
    endpoint: `${apiEndpoint}/public/me/orders`,
    method: 'GET',
    types: [
      FETCH_ORDERS_REQUEST,
      { type: FETCH_ORDERS_RECEIVE, [ROUTE]: redirectRoute },
      FETCH_ORDERS_FAILURE,
    ],
    options: { addAuth: true },
  },
});

export function getCCStoresEndpoint(location) {
  let q = '';
  if (typeof location === 'string') {
    q = `postcode=${encodeURIComponent(location)}`;
  } else {
    q = `lat=${encodeURIComponent(location.latitude)}&lon=${encodeURIComponent(
      location.longitude
    )}`;
  }
  return `${API_ENDPOINT}/locations/customer/?${q}&clickCollect=true`;
}
export const fetchCCStores = (location) => ({
  [CALL_API]: {
    endpoint: getCCStoresEndpoint(location),
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    types: preserveSequence([
      FETCH_CC_STORES_REQUEST,
      FETCH_CC_STORES_RECEIVE,
      FETCH_CC_STORES_FAILURE,
    ]).map((action) => ({
      ...action,
      meta: { ...action.meta, location },
    })),
    options: { addAuth: true },
  },
});

export const searchCCPharmacy = (text, apiEndpoint = API_ENDPOINT) => ({
  type: SEARCH_CCPHARMACY_VALIDATION,
  [validate]: {
    validator: () => text && text?.length,
    success: fetchCCStores(text, apiEndpoint),
    fail: { type: SET_EMPTY_LIST },
  },
});

export const addCCStoreItems = (selectedCCStorePharmacy, orderId) => {
  return {
    type: [SELECTED_CCSTORE_ITEM],
    payload: {
      selectedCCStorePharmacy,
      orderId,
    },
    [ROUTE]: `/orders/${orderId}/cc-confirm-pharmacy`,
  };
};

export const setDeliveryAddressOrderId = (orderId) => ({
  type: SET_DELIVERY_ADDRESS_ORDER_ID,
  payload: {
    orderId,
  },
});

export const checkoutOrderIdDetails = (orderId) => ({
  [CALL_API]: {
    endpoint: `${API_ENDPOINT}/pharmacy/public/order/${orderId}`,
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    types: [CCORDERID_REQUEST, CCORDERID_RESPONSE, CCORDERID_FAILURE],
    options: { addAuth: true },
  },
});

export const updateDeliveryPrefs = (
  orderId,
  selectedAddress,
  method = 'cc',
  flow,
  redirectRoute = '/'
) => {
  let payload = {};

  if (method === 'cc') {
    payload = {
      method,
      orderId,
      branchId: selectedAddress?.selectedCCStorePharmacy?.id,
    };
  } else {
    payload = {
      method,
      orderId,
      deliveryAddress: {
        line1: selectedAddress?.line1,
        line2: selectedAddress?.line2,
        city: selectedAddress?.city,
        postcode: selectedAddress?.postcode,
        country: selectedAddress?.city,
      },
    };
  }

  return {
    [CALL_API]: {
      endpoint: `${API_ENDPOINT}/pharmacy/public/${orderId.startsWith('R') ? 'requests' : 'orders'}/${orderId}/deliverypreferences`,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },  
      body: JSON.stringify(payload),
      types: [
        UPDATE_DELIVERY_REQUEST,
        {
          type: UPDATE_DELIVERY_RECEIVE,
          // [ROUTE]: redirectRoute,
          [CHAIN_NEXT]: () =>
            chainAPIActions(fetchOrders(PHARMACY_API, redirectRoute), () =>
              setDeliveryAddressOrderId(orderId)
            ),
        },
        {
          type: UPDATE_DELIVERY_FAILURE,
          [ROUTE]: redirectRoute,
        },
      ],
      options: { addAuth: true },
    },
  };
};

export const paymentSummaryRoutes = (type, exeption) => {
  return {
    type: [PAMENTSUMMARY_ROUTES],
    payload: {
      type,
      exeption,
    },
    [ROUTE]: paths.checkout.complete,
  };
};

export const paymentDeliveryPreferenceRoutes = (type, exeption) => {
  return {
    type: [PAYMENT_DELIVERY_PREFS_ROUTES],
    payload: {
      type,
      exeption,
    },
    [ROUTE]: paths.checkout.paymentMethod,
  };
};

export const confirmExemptionRoutes = (orderId) => {
  return {
    type: [CONFIRM_EXEMPTION_ROUTES],
    [ROUTE]: `/orders/${orderId}/change-delivery-preference`,
  };
};

export const selectCcPharmacyIndex = handleActions(
  {
    [FETCH_CC_STORES_REQUEST]: () => [],
    [FETCH_CC_STORES_RECEIVE]: () => [],
    [FETCH_CC_STORES_FAILURE]: () => [],
    [SELECTCCPharmacyINDEX]: (state, action) => action.payload,
  },
  null
);

export const clearAddItemError = () => ({
  type: CLEAR_ERROR_ADDING_ITEM,
});

export const fetchDeliveryPreferences = (orderId) => ({
  [CALL_API]: {
    endpoint: `${PHARMACY_API}/public/orders/${orderId}/deliverypreferences`,
    method: 'GET',
    types: [
      FETCH_DELIVERY_PREFERENCES_REQUEST,
      {
        type: FETCH_DELIVERY_PREFERENCES_RECEIVE,
        [TRACK_EVENT]: ORDERING_CHANGE_DELIVERY_PREFERENCE,
      },
      FETCH_DELIVERY_PREFERENCES_FAILURE,
    ],
    options: { addAuth: true },
  },
});

export const changeOrderDeliveryAddress = (
  orderId,
  address,
  redirectRoute = '/',
  apiEndpoint = PHARMACY_API
) => ({
  [CALL_API]: {
    endpoint: `${apiEndpoint}/public/orders/${orderId}/deliveryaddress`,
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line1: address.line1,
      line2: address.line2,
      city: address.city,
      postcode: address.postcode,
    }),
    types: [
      UPDATE_ORDER_DELIVERY_ADDRESS_REQUEST,
      {
        type: UPDATE_ORDER_DELIVERY_ADDRESS_RECEIVE,
        [ROUTE]: redirectRoute,
      },
      UPDATE_ORDER_DELIVERY_ADDRESS_FAILURE,
    ],
    options: { addAuth: true },
  },
});

export const validateOrderDeliveryAddressFailure = (
  address,
  validLine1,
  validLine1MaxLen,
  validLine2,
  validLine2MaxLen,
  validCity,
  validCityMaxLen,
  validPostcode
) => ({
  type: VALIDATE_ORDER_DELIVERY_ADDRESS_FAILURE,
  address,
  validLine1,
  validLine1MaxLen,
  validLine2,
  validLine2MaxLen,
  validCity,
  validCityMaxLen,
  validPostcode,
});

export const validateOrderDeliveryAddress = (address, flow, redirectRoute) => {
  const { orderId } = address;
  const validPostcode = isPostcodeValid(address.postcode);
  const validLine1 = isValidAddressLine(address.line1);
  const validLine1MaxLen = maxLengthValid(address.line1, addressLineMaxLen);
  const validLine2 =
    !notEmptyString(address.line2) || isValidAddressLine(address.line2);
  const validLine2MaxLen = maxLengthValid(address.line2, addressLineMaxLen);
  const validCity = isValidAddressLine(address.city);
  const validCityMaxLen = maxLengthValid(address.city, addressLineMaxLen);
  return {
    [validate]: {
      validator: () =>
        validPostcode &&
        validLine1 &&
        validLine1MaxLen &&
        validLine2 &&
        validLine2MaxLen &&
        validCity &&
        validCityMaxLen,
      success:
        flow === 'checkout' || flow === 'checkoutMethod'
          ? updateDeliveryPrefs(
              orderId,
              address,
              'standard',
              flow,
              redirectRoute
            )
          : changeOrderDeliveryAddress(orderId, address, redirectRoute),
      fail: validateOrderDeliveryAddressFailure(
        address,
        validLine1,
        validLine1MaxLen,
        validLine2,
        validLine2MaxLen,
        validCity,
        validCityMaxLen,
        validPostcode
      ),
    },
  };
};

export const setDeliveryPrefFlow = (flow) => ({
  type: SET_DELIVERY_PREFERENCE_FLOW,
  payload: {
    flow,
  },
});

export const setDeliveryPrefOrderId = ({ tPrefRadio, torderid }, flow) => {
  const isCheckoutFlow = flow === 'checkout';
  const isRoyalMailStandardDelivery =
    tPrefRadio === 'Royal Mail delivery' ||
    tPrefRadio === 'Royal Mail delivery rm';
  const paymentSummary = '/checkout/payment/summary';
  const defaultPath = '/';
  const ccPharmacyLocation = `/orders/${torderid}/cc-select-pharmacy`;
  return {
    type: SET_DELIVERY_PREF_ORDER_ID,
    payload: {
      tPrefRadio,
      torderid,
    },
    [ROUTE]: isCheckoutFlow
      ? isRoyalMailStandardDelivery
        ? paymentSummary
        : ccPharmacyLocation
      : isRoyalMailStandardDelivery
      ? defaultPath
      : ccPharmacyLocation,
  };
};

export const setPaymentAddressType = (value) => ({
  type: SET_PAYMENT_ADDRESS_TYPE,
  payload: value,
});

export const clearUpdateOrderDeliveryAddressError = () => ({
  type: CLEAR_UPDATE_ORDER_DELIVERY_ADDRESS_ERROR,
});

export const addReorderItems = (item, fromReorderList = false) => {
  if (!item) return { type: SET_ERROR_ADDING_ITEM };
  return {
    type: ADD_REORDER_ITEM,
    item,
    [ROUTE]: fromReorderList
      ? paths.createOrder.basket
      : paths.createOrder.root,
  };
};

export const basketFlowStarted = () => ({
  type: BASKET_FLOW_STARTED,
});

export const selectedccPharmacy = (index, orderId) => ({
  type: SELECTCCPharmacyINDEX,
  payload: {
    index,
    orderId,
  },
});

export const clearCCStore = (orderId) => ({
  type: CLEAR_CC_STORE,
  [ROUTE]: paths.checkout.paymentDeliveryPreference,
  payload: { orderId },
});

// SELECTORS
const THREE_DAYS_IN_MSEC = 3 * 86400e3;
const estimatedDeliveryDate = (isoDate) => {
  const date = new Date(isoDate);
  return new Date(date.getTime() + THREE_DAYS_IN_MSEC);
};

export const getPendingOrders = (state) =>
  state.orders.map((order) => ({
    ...order,
    id: order.id,
    invoiceId: order.invoiceId || '',
    status: order.status,
    medicines: order.medicines,
    deliveryDate:
      order.status === 'dispatched'
        ? estimatedDeliveryDate(order.lastUpdate)
        : undefined,
    lastModifiedDate: new Date(order.lastUpdate),
    deliveryAddress: order.deliveryAddress,
    ccStore: order.ccStore,
  }));

export const getOrders = (state) => state.orders || [];
export const getIsLoading = (state) => state.isLoading;
export const getErrorMessage = (state) => state.errorMessage;
export const getHasNoResults = (state) => state.noResults;
export const getFromHomeReorder = (state) => state.fromHomeReorder;
export const getDeliveryPreference = (state) =>
  state.pendingOrders.deliveryPreference;
export const getDeliveryPreferenceMethods = (state) =>
  state.pendingOrders.deliveryPreferenceMethods;
export const getDeliveryPreferenceFlow = (state) =>
  state.deliveryPreferenceFlow;
export const getDeliveryAddressOrderId = (state) =>
  state.deliveryAddressOrderId;
export const getUpdateOrderDeliveryAddressError = (state) =>
  state.updateOrderDeliveryAddressError;
export const getOrderDeliveryAddressErrors = (state) =>
  state.orderDeliveryAddressErrors || {};
export const getOrderDeliveryAddressLine1Error = (state) =>
  getOrderDeliveryAddressErrors(state).line1;
export const getOrderDeliveryAddressLine2Error = (state) =>
  getOrderDeliveryAddressErrors(state).line2;
export const getOrderDeliveryAddressTownCityError = (state) =>
  getOrderDeliveryAddressErrors(state).townCity;
export const getOrderDeliveryAddressPostcodeError = (state) =>
  getOrderDeliveryAddressErrors(state).postcode;
export const getCurrentDeliveryAddressForOrder = (state) => {
  const orderId = getDeliveryAddressOrderId(state);
  const orders = getPendingOrders(state);
  const order = orders.find((item) => item.id === orderId);
  if (order) {
    return order.deliveryAddress;
  }
  return {
    line1: '',
    line2: '',
    city: '',
    postcode: '',
  };
};
export const getCurrentCCStoreAddressForOrder = (state) => {
  const orderId = getDeliveryAddressOrderId(state);
  const orders = getPendingOrders(state);
  const order = orders.find((item) => item.id === orderId);
  return order?.ccStore ?? null;
};

export const getCurrentOrderById = (state) => {
  const orderId = getDeliveryAddressOrderId(state);
  const orders = getPendingOrders(state);
  const order = orders.find((item) => item.id === orderId);
  return order;
};
export const getCurrentOrderCCEligible = (state) => {
  const orderId = getDeliveryAddressOrderId(state);
  const orders = getPendingOrders(state);
  const order = orders.find((item) => item.id === orderId);
  return order?.ccEligible;
};

export const getSelectedCCLocationIndex = (state) =>
  state.selectCcPharmacyIndex;
export const getSearchText = (state) => state.searchCCStore;
export const getClickAndCollect = (state) =>
  state?.fromClickAndCollectStores || [];
export const getHasErrorAddingItem = (state) => state.CCStoreError;
export const getSelectedItem = (state) => state.addCCStoreItems;
export const getConfirmDetails = (state) => state.selectedStore;
export const getCCRMAddress = (state) => state.getRayalMailOrderIdAddress;
export const getPendingOrderDeliveryPreference = (state) =>
  state.deliveryPreference;
export const getPaymentSummarySelectedMessage = (state) =>
  state.paymentSummaryRoutesSelectMessage;

// REDUCERS

export const orders = handleActions(
  {
    [FETCH_ORDERS_REQUEST]: () => [],
    [FETCH_ORDERS_FAILURE]: () => [],
    [FETCH_ORDERS_RECEIVE]: (state, action) => action.payload.data,
    // Remove CC Store from orders list for the selected order
    [CLEAR_CC_STORE]: (state, action) => {
      return state.map((order) => {
        if (order.id === action.payload.orderId) {
          return {
            ...order,
            ccStore: null,
          };
        }
        return order;
      });
    },
  },
  []
);
export const noResults = handleActions(
  {
    [FETCH_ORDERS_REQUEST]: () => false,
    [FETCH_ORDERS_FAILURE]: () => false,
    [FETCH_ORDERS_RECEIVE]: (state, action) => action.payload.data.length === 0,
  },
  false
);

export const isLoading = handleActions(
  {
    [FETCH_ORDERS_REQUEST]: () => true,
    [FETCH_ORDERS_FAILURE]: () => false,
    [FETCH_ORDERS_RECEIVE]: () => false,
  },
  false
);

export const errorMessage = handleActions(
  {
    [FETCH_ORDERS_REQUEST]: () => null,
    [FETCH_ORDERS_FAILURE]: (state, action) => getAPIErrorMessage(action),
    [FETCH_ORDERS_RECEIVE]: () => null,
  },
  null
);

export const deliveryAddressOrderId = handleActions(
  {
    [SET_DELIVERY_ADDRESS_ORDER_ID]: (state, action) => action.payload.orderId,
    [FETCH_ORDERS_REQUEST]: () => '0',
    [UPDATE_ORDER_DELIVERY_ADDRESS_RECEIVE]: () => '0',
    [FETCH_INVOICE_RECEIVE]: (state, action) =>
      `S${action.payload.invoice.orderId}`,
    [FETCH_INVOICE_REQUEST]: () => '0',
  },
  '0'
);

export const deliveryPreferenceFlow = handleActions(
  {
    [SET_DELIVERY_PREFERENCE_FLOW]: (state, action) => action.payload.flow,
    [FETCH_INVOICE_RECEIVE]: () => 'checkout',
    [FETCH_ORDERS_REQUEST]: () => '0',
    [FETCH_ORDERS_RECEIVE]: (state, action) =>
      action.payload?.redirect ? state.deliveryPreferenceFlow : '0',
    [UPDATE_ORDER_DELIVERY_ADDRESS_RECEIVE]: () => '0',
  },
  '0'
);

export const deliveryPreferenceMethods = handleActions(
  {
    [FETCH_DELIVERY_PREFERENCES_RECEIVE]: (state, action) => action.payload,
    [FETCH_ORDERS_REQUEST]: () => '0',
    [UPDATE_ORDER_DELIVERY_ADDRESS_RECEIVE]: () => '0',
  },
  '0'
);

const initialDeliveryPreference = {
  tPrefRadio: 'Royal Mail delivery',
};
export const deliveryPreference = handleActions(
  {
    [SET_DELIVERY_PREF_ORDER_ID]: (state, action) => {
      return action.payload;
    },
  },
  initialDeliveryPreference
);

const updateOrderDeliveryAddressError = handleActions(
  {
    [UPDATE_ORDER_DELIVERY_ADDRESS_FAILURE]: (state, action) =>
      getAPIErrorMessage(action) || 'Something went wrong.',
    [UPDATE_ORDER_DELIVERY_ADDRESS_REQUEST]: () => null,
    [CLEAR_UPDATE_ORDER_DELIVERY_ADDRESS_ERROR]: () => null,
  },
  null
);

const orderDeliveryAddressErrors = handleActions(
  {
    [VALIDATE_ORDER_DELIVERY_ADDRESS_FAILURE]: (state, action) => ({
      line1: action.validLine1
        ? action.validLine1MaxLen
          ? null
          : 'Character limit exceeded. Please continue address on line 2.'
        : 'Address cannot contain special characters',
      line2: action.validLine2
        ? action.validLine2MaxLen
          ? null
          : 'Character limit exceeded'
        : 'Address cannot contain special characters',
      townCity: action.validCity
        ? action.validCityMaxLen
          ? null
          : 'Character limit exceeded'
        : 'Address cannot contain special characters',
      postcode: action.validPostcode ? null : 'Postcode is invalid',
    }),
    [UPDATE_ORDER_DELIVERY_ADDRESS_REQUEST]: () => null,
  },
  null
);
export const searchCCStore = handleActions(
  {
    [SET_EMPTY_LIST]: () => '',
    [FETCH_CC_STORES_REQUEST]: (state, action) => action.meta.location,
  },
  ''
);
export const fromHomeReorder = handleActions(
  {
    [ADD_REORDER_ITEM]: () => true,
    [BASKET_FLOW_STARTED]: () => false,
  },
  false
);

export const fromClickAndCollectStores = handleActions(
  {
    [FETCH_CC_STORES_REQUEST]: () => [],
    [FETCH_CC_STORES_FAILURE]: () => [],
    [FETCH_CC_STORES_RECEIVE]: (state, action) => action.payload,
  },
  []
);

export const CCStoreError = handleActions(
  {
    [FETCH_CC_STORES_REQUEST]: () => [],
    [FETCH_CC_STORES_FAILURE]: () => [],
    [FETCH_CC_STORES_FAILURE]: () => true,
  },
  false
);

export const selectedStore = handleActions(
  {
    [SELECTED_CCSTORE_ITEM]: (state, action) => action.payload,
    [FETCH_INVOICE_RECEIVE]: (state, action) => ({
      selectedCCStorePharmacy: action.payload.ccStore,
    }),
    [FETCH_INVOICE_REQUEST]: () => null,
    [CLEAR_CHECKOUT_FLOW]: () => null,
  },
  null
);

export const updateDeliveryPrefsStores = handleActions(
  {
    [UPDATE_DELIVERY_REQUEST]: (state, action) => action.payload,
    [UPDATE_DELIVERY_REQUEST]: () => [],
    [UPDATE_DELIVERY_FAILURE]: (state, action) => action.payload,
  },
  []
);

export const getRayalMailOrderIdAddress = handleActions(
  {
    [CCORDERID_REQUEST]: (state, action) => action.payload,
    [CCORDERID_FAILURE]: (state, action) => action.payload,
    [CCORDERID_RESPONSE]: (state, action) => action.payload,
    [FETCH_INVOICE_RECEIVE]: (state, action) => action.payload.deliveryAddress,
    [FETCH_INVOICE_REQUEST]: () => null,
  },
  null
);

const initialState = {
  paymentAddressType: false,
};

export const paymentSummaryRoutesSelectMessage = handleActions(
  {
    [PAMENTSUMMARY_ROUTES]: (state, action) => action.payload,
  },
  initialState
);

export default combineReducers({
  orders,
  isLoading,
  errorMessage,
  noResults,
  deliveryAddressOrderId,
  deliveryPreferenceFlow,
  deliveryPreferenceMethods,
  updateOrderDeliveryAddressError,
  orderDeliveryAddressErrors,
  fromHomeReorder,
  deliveryPreference,
  fromClickAndCollectStores,
  CCStoreError,
  clearAddItemError,
  selectCcPharmacyIndex,
  selectedStore,
  searchCCStore,
  updateDeliveryPrefsStores,
  getRayalMailOrderIdAddress,
  paymentSummaryRoutesSelectMessage,
});
